import { HttpProxyConfig } from "../types/config";
import { proxify } from "./proxy";

type LonLat = { longitude: number; latitude: number };

export async function queryLayersAtPoint(
  featureServiceBaseUrl: string,
  layerIds: number[],
  center: LonLat,
  proxy?: HttpProxyConfig
): Promise<Record<number, any[]>> {
  const base = featureServiceBaseUrl.replace(/\/+$/, "");
  const geom = JSON.stringify({
    x: center.longitude,
    y: center.latitude,
    spatialReference: { wkid: 4326 }
  });

  const byLayer: Record<number, any[]> = {};
  await Promise.all(
    layerIds.map(async (id) => {
      const url = proxify(`${base}/${id}/query`, proxy);
      const params = new URLSearchParams({
        f: "json",
        where: "1=1",
        geometry: geom,
        geometryType: "esriGeometryPoint",
        inSR: "4326",
        spatialRel: "esriSpatialRelIntersects",
        outFields: "*",
        outSR: "4326",
        returnGeometry: "false"
      });
      const resp = await fetch(`${url}?${params.toString()}`);
      if (!resp.ok) return;
      const json = await resp.json();
      byLayer[id] = (json.features ?? []).map((f: any) => f.attributes || {});
    })
  );
  return byLayer;
}